import { useContent } from "@/shared/lib/i18n";
import { links } from "@/shared/config/site";

const DOC_HREFS = [links.legal.privacy, links.legal.partnership] as const;

export function Footer() {
  const { footer } = useContent();

  return (
    <footer className="bg-ink border-t border-white/5">
      <div className="mx-auto max-w-[1760px] px-[14px] lg:px-20 py-10 lg:py-12">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 justify-between items-stretch">
          {/* Logo */}
          <div className="shrink-0">
            <div className="flex items-center gap-2.5">
              <img src="/craff-logo.svg" alt="Craff" width={29} height={42} />
              <span className="text-[17px] font-semibold text-[#fbfbfb]">Craff</span>
            </div>
            <p className="mt-2 text-sm text-white/40">{footer.brandTagline}</p>
          </div>

          {/* Menu */}
          <div>
            <p className="text-sm font-semibold text-white mb-4 lg:mb-5">{footer.menuTitle}</p>
            <div className="grid grid-cols-2 gap-x-12 gap-y-3">
              {footer.nav.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm text-[#f4a425] hover:text-[#fec201] transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Documents */}
          <div>
            <p className="text-sm font-semibold text-white mb-4 lg:mb-5">{footer.docsTitle}</p>
            <div className="flex flex-col gap-3">
              {footer.docs.map((item, i) => (
                <a
                  key={item.label}
                  href={DOC_HREFS[i]}
                  className="text-sm text-[#f4a425] hover:text-[#fec201] transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <p className="text-xs text-muted-fg mt-8 lg:mt-6">
          {footer.copyright.replace("{year}", String(new Date().getFullYear()))}
        </p>
      </div>
    </footer>
  );
}
